import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function IdentificationSection() {
  return <section className="py-20 md:py-32 bg-[#FAF7F2] text-[#2D1B4E]" data-id="element-94">
      <div className="container mx-auto px-4 md:px-6" data-id="element-95">
        <div className="max-w-3xl mx-auto text-center" data-id="element-96">
          <FadeIn data-id="element-97">
            <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-98">
              Does this sound familiar?
            </h2>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-99">
            <div className="space-y-6 text-lg md:text-xl leading-relaxed text-gray-700" data-id="element-100">
              <p data-id="element-101">
                You function well on the outside, but inside there’s tension
                that never fully leaves.
              </p>
              <p data-id="element-102">
                You’ve learned to smile through it, yet certain emotional
                patterns keep repeating.
              </p>
              <p className="font-medium text-[#2D1B4E]" data-id="element-103">
                Maybe you’ve done the work—so why does it still show up?
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-104">
            <div className="mt-12 h-1 w-24 bg-[#D4A574] mx-auto rounded-full" data-id="element-105" />
          </FadeIn>
        </div>
      </div>
    </section>;
}